import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import GridReal from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { LogsService } from '~/services/log-exports';
import { clearDimensionCache } from '~/api/dimensions';
import Snackbar from '@mui/material/Snackbar';
import { Component } from 'react';

const Grid = styled(GridReal)({
  padding: '4px',
});

export default class AdminPage extends Component {

    state = {snackbar: { show: false, message: '' }};

  DownloadLogs = async () => {
    await LogsService.downloadLogs();
  };

  ClearDimensionCache = async () => {
      try {
          await clearDimensionCache();
      } catch (error: any) {
          this.setState({ snackbar: { show: true, message: error.message } });
      }
  };

  render() {
    return (
      <>
        <Grid container item xs={12} lg={10} spacing={2}>
          <Grid item>
            <Typography variant="h4">Serverloggar</Typography>
            <Typography>Här finns möjlighet att ladda ner serverloggarna.</Typography>
          </Grid>
        </Grid>
        <Grid container item xs={12} lg={10} spacing={2}>
          <Grid item>
            <Button variant="contained" color={'primary'} onClick={() => this.DownloadLogs()}>
              Ladda ner loggar
            </Button>
          </Grid>
        </Grid>
        <Grid container item xs={12} lg={10} spacing={2}>
          <Grid item>
            <Typography variant="h4">Töm dimension cache</Typography>
            <Typography>Här finns möjlighet att rensa dimensions cachen.</Typography>
          </Grid>
        </Grid>
        <Grid container item xs={12} lg={10} spacing={2}>
          <Grid item>
            <Button variant="contained" color={'primary'} onClick={() => this.ClearDimensionCache()}>
              Delete cache
            </Button>
          </Grid>
        </Grid>
          <Snackbar
              open={this.state.snackbar.show}
              message={this.state.snackbar.message}
              autoHideDuration={6000}
              onClose={() => this.setState({ snackbar: { show: false, message: '' } })}
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          />
      </>
    );
  }
}
